const config = {
    protocol:"https",
    // host: "www.sxyyxh.cn",
    host: "api.100xsys.cn",
    // prefix:"/bxapi",
    prefix:"",
    port:"",
    domain:"www.sxyyxh.cn",   // 用户端域名
    title:"陕西省营养学会",
    webNo:"PCWS202307110001", 
    isAuth:false,
    webLayout:['hander','navs','footer'],  // 布局部件  hander 顶部  ， navs  一级导航   footer 底部栏  // 页面内容区域默认根据路由加载
    navs:{
        navbarShowChildren:false
    },
    hander:{
        login:{
            inputText:'注册登录',
            layoutTitle:"个人会员登录",
            layoutMsg:"还没有账号，点击下方【立即注册】进行在线注册",
            show:true,
            loginPath:"/login",
            toHome:true
        },
        register:'',
        // {
        //     text:'注册',
        //     show:true,
        //     layoutTitle:"个人会员注册",
        //     layoutMsg:"",
        //     loginPath:"/register",
        //     toHome:true,
        //     toLogin:true
        // },
        search:{
            text:'搜索',
            icon:"",
            show:true
        }
    },
    footer:{
        navs:false,
        copyright:true
    }
}
module.exports = { ...config }
